import http from '@utils/http';

/**
 * GET /api/v1/analytics/dashboard
 * Admin: stats { activeProjects, activeClients, activeEmployees, revenue }
 * Client: stats { activeProjects, completedProjects, spendings }
 */
export const getDashboardAnalytics = ({ view } = {}) =>
    http
        .get('/analytics/dashboard', {
            params: view ? { view } : undefined,
        })
        .then((res) => {
        const raw = res.data?.data ?? res.data;
        return {
            view: raw?.view ?? 'admin',
            stats: raw?.stats ?? {},
            recentNotifications: Array.isArray(raw?.recentNotifications) ? raw.recentNotifications : [],
            recentProjects: Array.isArray(raw?.recentProjects) ? raw.recentProjects : [],
            activityLogs: Array.isArray(raw?.activityLogs) ? raw.activityLogs : [],
        };
    });
